import React, { useEffect } from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (isAuthenticated()) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card style={{ width: '100%', maxWidth: '500px' }}>
        <Card.Body className="text-center p-5">
          <img
            src={`${process.env.PUBLIC_URL}/ursulai-logo-small.png`}
            alt="UrsulaI Logo"
            style={{ width: '120px', marginBottom: '2rem' }}
            onError={(e) => {
              e.target.src = `${process.env.PUBLIC_URL}/ursulai-logo-1.png`;
              e.target.style.width = '200px';
            }}
          />
          <h2 className="mb-4">Welcome to UrsulaI</h2>
          <p className="text-muted mb-4">
            Sign in to access the voice AI marketplace, create custom voice models,
            and license voices for your projects.
          </p>

          <div className="d-grid gap-3">
            <div className="alert alert-info">
              <small>
                <strong>Authentication via Authelia</strong><br />
                Click below to sign in through our secure authentication portal.
                You'll be redirected back after authentication.
              </small>
            </div>

            <Button
              variant="primary"
              size="lg"
              onClick={() => {
                // Store the return URL for after auth
                sessionStorage.setItem('authReturnUrl', window.location.origin + '/dashboard');
                // Redirect to protected endpoint - Authelia will intercept and show login
                window.location.href = '/api/auth/profile';
              }}
            >
              Sign In with Authelia
            </Button>

            <Button
              variant="outline-primary"
              size="lg"
              onClick={() => navigate('/marketplace')}
            >
              Browse as Guest
            </Button>

            <div className="text-muted small mt-3">
              <p>
                New to UrsulaI? The sign-in portal will allow you to create an account
                or sign in with Google, GitHub, or email.
              </p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Login;
